import Splide from '@splidejs/splide'

export default function Sliders() {
	// --- Banner Slider ---
	const bannerElements = document.querySelector('.js-banner-slider')
	bannerElements && new Splide('.js-banner-slider', {
		type: 'loop',
		arrows: true,
		pagination: false,
		keyboard: false,
		drag: true,
		rewind: true,
		autoplay: true,
		speed: 1000,
		interval: 5000,
		pauseOnHover: false,
		snap: true,
		autoHeight: true,
		classes: {
			arrows: 'splide__arrows',
			arrow: 'splide__arrow',
			prev: 'splide__arrow--prev',
			next: 'splide__arrow--next',
		},
	}).mount()

	// --- USP Slider ---
	const uspElements = document.querySelector('.js-usp-slider')
	uspElements && new Splide('.js-usp-slider', {
		type: 'slide',
		perPage: 1,
		perMove: 1,
		pagination: false,
		gap: 20,
		arrows: false,
		mediaQuery: 'min',
		breakpoints: {
			767: {
				perPage: 2,
			},
			1023: {
				perPage: 3,
			},
			1439: {
				perPage: 4,
			},
		},
	}).mount()

	// --- Logos Slider ---
	const logosElements = document.querySelector('.js-logo-slider')
	logosElements && new Splide('.js-logo-slider', {
		type: 'loop',
		perPage: 1,
		perMove: 1,
		gap: 20,
		pagination: false,
		arrows: false,
		mediaQuery: 'min',
		autoplay: true,
		speed: 1000,
		interval: 5000,
		breakpoints: {
			450: {
				perPage: 2,
			},
			767: {
				perPage: 3,
				gap: 40,
			},
			1023: {
				perPage: 4,
			},
			1279: {
				perPage: 6,
			},
		},
	}).mount()

	// --- Product Feed Sliders ---
	const productFeed = document.querySelectorAll('.js-product-slider')
	for (let i = 0; i < productFeed.length; i++) {
		new Splide(productFeed[i], {
			type: 'slide',
			perPage: 1,
			perMove: 1,
			gap: 20,
			pagination: false,
			arrows: true,
			mediaQuery: 'min',
			autoplay: false,
			breakpoints: {
				767: {
					perPage: 2,
				},
				1023: {
					perPage: 3,
				},
				1279: {
					perPage: 5,
				},
			},
			classes: {
				arrows: 'splide__arrows',
				arrow: 'splide__arrow',
				prev: 'splide__arrow--prev',
				next: 'splide__arrow--next',
			},
		}).mount()
	}

	// --- Gallery Sliders ---
	const galleries = document.querySelectorAll('.js-gallery')

	if (galleries.length) {
		galleries.forEach(gallery => {
			const masterGallery = gallery.querySelector('.js-master-gallery')
			const thumbnails = gallery.querySelector('.js-thumbnail-gallery')

			if (!masterGallery || !thumbnails) return

			const mainSlider = new Splide(masterGallery, {
				arrows: false,
				pagination: false,
				keyboard: false,
				drag: true,
				autoplay: false,
				snap: true,
				gap: '20px',
				perPage: 1,
			})

			const thumbnailsSlider = new Splide(thumbnails, {
				arrows: true,
				pagination: false,
				keyboard: false,
				drag: true,
				autoplay: false,
				snap: true,
				gap: '10px',
				isNavigation: true,
				perPage: 3,
				mediaQuery: 'min',
				breakpoints: {
					768: {
						gap: '20px',
						perPage: 4,
					},
					1280: {
						perPage: 3,
					},
					1440: {
						perPage: 4,
					}
				},
			})

			mainSlider.sync( thumbnailsSlider )
			mainSlider.mount()
			thumbnailsSlider.mount() 
		})
	}
}
